import GET_VIDEOS_BY_LOCATION_ID from '@amzn/ring-neighbors-api-orchestrator-gql-schema/operations/authenticated/posting/getVideosByLocationId.graphql';
import { useQueryWithBoundary } from 'src/hooks';

export const normalizeVideo = (video: any) => ({
  id: video.node.id,
  deviceName: video.node.device.name,
  deviceType: video.node.device.type,
  startTime: video.node?.details.start_time,
  type: video.node?.details.type,
  url: video.node?.details.media?.[0].url,
  thumbnailUrl: video.node?.details.media?.[0].thumbnail?.url,
  hasSubscription: video.node?.details?.has_subscription,
  cv: video.node?.details?.cv,
  properties: video.node?.details?.properties,
  state: video.node?.details?.state,
});

export const normalizePageInfo = (pageInfo: any = {}) => ({
  hasNextPage: pageInfo.hasNextPage,
  endCursor: pageInfo.endCursor,
});

export const useGetVideosByLocationId = (locationId: string | null) => {
  const { data, ...rest } = useQueryWithBoundary(GET_VIDEOS_BY_LOCATION_ID, {
    // 10 minutes interval
    pollInterval: 600000,
    variables: {
      location_id: locationId,
    },
    skip: !locationId,
  });

  if (data) {
    return {
      ...rest,
      data: {
        videos: data.ringVideosByLocationId?.edges.map(normalizeVideo),
        ...normalizePageInfo(data.ringVideosByLocationId.pageInfo),
      },
    };
  }

  return {
    ...rest,
    data: {
      videos: [],
      hasNextPage: false,
      endCursor: null,
    },
  };
};
